<template>
  <div>
    <!-- 所管会社 -->
    <div class="row" style="margin-top: 4px" >
      <div class="col-xs-4">
        <label for="company">所管会社</label>
      </div>
      <div class="col-xs-8">
        <select class="form-control select-box limited-height-box" style="height: 24px; font-size: 12px" 
        @change="onSearchValue('company', $event.target.value)" id="company" v-model="valCompany">
          <option v-for="o in optCompany" :data="o" :key="o" :value="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <!-- 所管部署 -->
    <div class="row" style="margin-top: 4px" v-if="onlyCompany != true" >
      <div class="col-xs-4">
        <label for="department">所管部署</label>
      </div>
      <div class="col-xs-8">
        <select class="form-control select-box limited-height-box" style="height: 24px; font-size: 12px" 
        :disabled="optDepartment.length == 0"
        @change="onSearchValue('department', $event.target.value)" id="department" v-model="valDepartment">
          <option v-for="o in optDepartment" :data="o" :key="o" :value="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <!-- 所管チーム -->
    <div class="row" style="margin-top: 4px"  v-if="onlyCompany != true">
      <div class="col-xs-4">
        <label for="team">所管チーム</label>
      </div>
      <div class="col-xs-8">
        <select class="form-control select-box limited-height-box" style="height: 24px; font-size: 12px"
        :disabled="optTeam.length == 0"
        @change="onSearchValue('team', $event.target.value)" id="team" v-model="valTeam">
          <option v-for="o in optTeam" :data="o" :key="o" :value="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <!-- 所管区分 -->
    <div class="row" style="margin-top: 4px"  v-if="onlyCompany != true">
      <div class="col-xs-4">
        <label for="jurisdiction_classification">所管区分</label>
      </div>
      <div class="col-xs-8">
        <select class="form-control select-box limited-height-box" style="height: 24px; font-size: 12px"
        @change="onSearchValue('jurisdiction_classification', $event.target.value)" id="jurisdiction_classification" v-model="valJurisdictionClassification">
          <option v-for="o in optJurisdictionClassification" :data="o" :key="o" :value="o">{{ o }}</option>
        </select>
      </div>
    </div>
    <!-- 所管システム -->
    <div class="row" style="margin-top: 4px"  v-if="onlyCompany != true">
      <div class="col-xs-4">
        <label for="license_jurisdiction_system">所管システム</label>
      </div>
      <div class="col-xs-8">
        <select class="form-control select-box  limited-height-box" style="height: 24px; font-size: 12px"
        :disabled="valJurisdictionClassification != 'IT所管システム'"
        @change="onSearchValue('license_jurisdiction_system', $event.target.value)" id="license_jurisdiction_system" v-model="valJicenseJurisdictionSystem">
          <option v-for="o in optJicenseJurisdictionSystem" :data="o" :key="o" :value="o">{{ o }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
import _ from "lodash";
import { fields, filed_types } from "@/rules/fields_certificate_software";
import debug from "debug";
var debug_msg = debug("esma:information-modal");

export default {
  data() {
    return {
      all_company: [],
      all_departments: [],
      val_company: "",
      val_jurisdiction_classification: "",
      val_licensed_department: "",
      val_license_jurisdiction_team: "",
      val_license_jurisdiction_system: "",
      opt_company: [],
      opt_jurisdiction_classification: fields.jurisdiction_classification.options,
      opt_licensed_department: [],
      opt_license_jurisdiction_team: [],
      opt_license_jurisdiction_system: [],
      name_map:{
        company:"company",
        jurisdiction_classification:"jurisdiction_classification",
        license_jurisdiction_system:"license_jurisdiction_system",
        department:"licensed_department",
        team:"license_jurisdiction_team"
      }
    };
  },
  computed: {
    valCompany: {
      get() {
        return this.val_company;
      },
      set(v) {
        this.val_company = v;
      },
    },
    valJurisdictionClassification: {
      get() {
        return this.val_jurisdiction_classification;
      },
      set(v) {
        this.val_jurisdiction_classification = v;
      },
    },
    valDepartment: {
      get() {
        return this.val_licensed_department;
      },
      set(v) {
        this.val_licensed_department = v;
      },
    },
    valTeam: {
      get() {
        return this.val_license_jurisdiction_team;
      },
      set(v) {
        this.val_license_jurisdiction_team = v;
      },
    },
    valJicenseJurisdictionSystem: {
      get() {
        return this.val_license_jurisdiction_system;
      },
      set(v) {
        this.val_license_jurisdiction_system = v;
      },
    },
    optCompany: {
      get() {
        return this.opt_company;
      },
      set(v) {
        this.opt_company = v;
      },
    },
    optJurisdictionClassification: {
      get() {
        return this.opt_jurisdiction_classification;
      },
      set(v) {
        this.opt_jurisdiction_classification = v;
      },
    },
    optDepartment: {
      get() {
        return this.opt_licensed_department;
      },
      set(v) {
        this.opt_licensed_department = v;
      },
    },
    optTeam: {
      get() {
        return this.opt_license_jurisdiction_team;
      },
      set(v) {
        this.opt_license_jurisdiction_team = v;
      },
    },
    optJicenseJurisdictionSystem: {
      get() {
        return this.opt_license_jurisdiction_system;
      },
      set(v) {
        this.opt_license_jurisdiction_system = v;
      },
    },
    localFields: {
      get() {
        return fields;
      },
      set(v) {},
    },
    onlyCompany(){
      return this.$props.only_company
    }
  },
  methods: {
    onSearchValue(id,val){
      if(id=="jurisdiction_classification" ){
        if(val != "IT所管システム"){
          this.$emit("search",[
            {id:this.name_map["jurisdiction_classification"],val},
            {id:this.name_map["license_jurisdiction_system"],val:""},
            ])
        }else{
            this.$emit("search",[
            {id:this.name_map["jurisdiction_classification"],val}
            ])
        }
        this.valJicenseJurisdictionSystem = ""
      }else if(id=="company"){
        if(this.onlyCompany){
          this.$emit("search",{id:this.name_map["company"],val})
        }else{
          this.optDepartment = _.uniq(_.filter(this.all_departments,(o)=>{return o.company == val}).map(m=>{return m.department;}))
          this.optTeam = _.uniq(_.filter(this.all_departments,(o)=>{return o.company == val && o.department == this.valDepartment}).map(m=>{return m.team;}))
          this.valDepartment = "";
          this.valTeam = "";
          this.valJurisdictionClassification = "";
          this.valJicenseJurisdictionSystem = "";
          this.$emit("search",[
            {id:this.name_map["company"],val},
            {id:this.name_map["department"],val:""},
            {id:this.name_map["team"],val:""},
            {id:this.name_map["jurisdiction_classification"],val:""},
            {id:this.name_map["license_jurisdiction_system"],val:""}
          ])
        }
      }else if(id=="department"){
        this.valTeam = "";
        this.valJurisdictionClassification = "";
        this.valJicenseJurisdictionSystem = "";
        this.$emit("search",[
          {id:this.name_map["department"],val},
          {id:this.name_map["team"],val:""},
          {id:this.name_map["jurisdiction_classification"],val:""},
          {id:this.name_map["license_jurisdiction_system"],val:""}
        ])
        this.optTeam = _.uniq(_.filter(this.all_departments,(o)=>{return o.company == this.valCompany && o.department == val}).map(m=>{return m.team;}))
      }else if(id=="team"){
        this.valJurisdictionClassification = "";
          this.valJicenseJurisdictionSystem = "";
        this.$emit("search",[
          {id:this.name_map[id],val},
          {id:this.name_map["jurisdiction_classification"],val:""},
          {id:this.name_map["license_jurisdiction_system"],val:""}
        ])
      }else if(id=="license_jurisdiction_system"){
        this.$emit("search",[{id:this.name_map[id],val}])
      }
    }
  },
  props: {
       only_company: { type: Boolean, default:false }
  },
  mounted() {
    this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
        this.optCompany = _companies.map(m=>{return m.val});

        this.$ajax.post_cached_queued( "/master_belongs/list_team_and_department", {}, (err, department_and_team) => {
            this.all_departments = department_and_team;
            this.$ajax.post_cached_queued( "/master_system/list_system_name", {}, (err, list_system_name) => {
              this.optJicenseJurisdictionSystem = list_system_name.map(m=>{return m.val});

              if(this.optCompany.length == 1){
                setTimeout(() => {
                  this.valCompany = this.optCompany[0]
                  this.onSearchValue("company",this.optCompany[0])
                }, 200);
              }
            });
          }
        );
      }
    );
  },
  beforeDestroy() {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// search-company.vue?b587660c